/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Metrics_Show_CpsInputs */

const en_options_metrics_show_cps = /** @type {(inputs: Options_Metrics_Show_CpsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Show Characters Per Second (CPS)`)
};

const fr_options_metrics_show_cps = /** @type {(inputs: Options_Metrics_Show_CpsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Show Characters Per Second (CPS)`)
};

const de_options_metrics_show_cps = /** @type {(inputs: Options_Metrics_Show_CpsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Show Characters Per Second (CPS)`)
};

const it_options_metrics_show_cps = /** @type {(inputs: Options_Metrics_Show_CpsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Show Characters Per Second (CPS)`)
};

const ru_options_metrics_show_cps = /** @type {(inputs: Options_Metrics_Show_CpsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Show Characters Per Second (CPS)`)
};

const es_options_metrics_show_cps = /** @type {(inputs: Options_Metrics_Show_CpsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Show Characters Per Second (CPS)`)
};

const zh_cn2_options_metrics_show_cps = /** @type {(inputs: Options_Metrics_Show_CpsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Show Characters Per Second (CPS)`)
};

const ja_options_metrics_show_cps = /** @type {(inputs: Options_Metrics_Show_CpsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Show Characters Per Second (CPS)`)
};

const hi_options_metrics_show_cps = /** @type {(inputs: Options_Metrics_Show_CpsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Show Characters Per Second (CPS)`)
};

const pt_pt2_options_metrics_show_cps = /** @type {(inputs: Options_Metrics_Show_CpsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Show Characters Per Second (CPS)`)
};

/**
* | output |
* | --- |
* | "Show Characters Per Second (CPS)" |
*
* @param {Options_Metrics_Show_CpsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_metrics_show_cps = /** @type {((inputs?: Options_Metrics_Show_CpsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Metrics_Show_CpsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_options_metrics_show_cps(inputs)
	if (locale === "de") return de_options_metrics_show_cps(inputs)
	if (locale === "it") return it_options_metrics_show_cps(inputs)
	if (locale === "ru") return ru_options_metrics_show_cps(inputs)
	if (locale === "es") return es_options_metrics_show_cps(inputs)
	if (locale === "zh-CN") return zh_cn2_options_metrics_show_cps(inputs)
	if (locale === "ja") return ja_options_metrics_show_cps(inputs)
	if (locale === "hi") return hi_options_metrics_show_cps(inputs)
	if (locale === "pt-PT") return pt_pt2_options_metrics_show_cps(inputs)
	return en_options_metrics_show_cps(inputs)
});